// Partners component
import React from "react";
import NavBar from "./NavBar";
import Footer from "./Footer";
import '../styles/Partners.css';

function Partners(){

    const PartnersData = [
        {
            id: "solidaridad",
            name: "Solidaridad",
            image_url: "/images/partners-logo/partner - solidaridad.png"
        },
        {
            id: "usiu",
            name: "United States International University-Africa (USIU -Africa)",
            image_url: "/images/partners-logo/partner - usiu.png"
        },
        {
            id: "weac",
            name: "Women's Entrepreneurship Access Center (WEAC)",
            image_url: "/images/partners-logo/partner - WEAClogo.png"
        },
        {
            id: "gt-bank",
            name: "Guaranty Trust Bank",
            image_url: "/images/partners-logo/partner - gt-bank.png"
        },
        {
            id: "restless-development-zambia",
            name: "Restless development - Zambia",
            image_url: "/images/partners-logo/partner - restless dev.jpeg"
        },
        {
            id: "fnb",
            name: "First National Bank",
            image_url: "/images/partners-logo/partner - fnb.jpg"
        },
        {
            id: "challenges-group",
            name: "Challenges Group",
            image_url: "/images/partners-logo/partner - challenges group.png"
        },
        {
            id: "jadfad-consultants",
            name: "Jadfad Consultants",
            image_url: "/images/partners-logo/partner - jadfad.png"
        },
        {
            id: "care-international",
            name: "CARE International",
            image_url: "/images/partners-logo/care-international-logo-vector.png"
        },
        {
            id: "shaba-capital",
            name: "Shaba Capital",
            image_url: "/images/partners-logo/shaba-capital-logo-dark.png"
        },
    ]

    return (
        <div className="partners-component">
            <NavBar />
            <div className="partners">
                <h1>Stronger Together – Meet Our Trusted <span>Partners</span></h1>
                {/* Partners container */}
                <div className="partners-container">
                    {PartnersData.map(partner => (
                        <div className="partner-card" key={partner.id}>
                            <img src={partner.image_url} alt={partner.name}/>
                            <p>{partner.name}</p>
                        </div>
                    ))}
                </div>
            </div>
            <Footer />
        </div>  
    )
}

export default Partners;